import Frames from "@fae/source/engine/animating/Frames.js"

export default {
    "static": require("./lord-idle-0.png"),
    "idle": {
        "frames": Frames.run({
            "tweentime": 100,
            "images": [
                require("./lord-idle-0.png"),
                require("./lord-idle-0.png"),
                require("./lord-idle-0.png"),
                require("./lord-idle-0.png"),
                require("./lord-idle-0.png"),
                require("./lord-idle-0.png"),
                require("./lord-idle-0.png"),
                require("./lord-idle-0.png"),
                require("./lord-idle-1.png"),
                require("./lord-idle-2.png"),
                require("./lord-idle-3.png"),
                require("./lord-idle-4.png"),
                require("./lord-idle-5.png"),
                require("./lord-idle-6.png"),
                require("./lord-idle-7.png"),
                require("./lord-idle-7.png"),
                require("./lord-idle-7.png"),
                require("./lord-idle-7.png"),
            ]
        })
    },
    "ready": {
        "frames": Frames.run({
            "tweentime": 60,
            "images": [
                require("./lord-selected-3.png"),
                require("./lord-selected-4.png"),
                require("./lord-selected-5.png"),
                require("./lord-selected-6.png"),
                require("./lord-selected-6.png"),
                require("./lord-selected-6.png"),
                require("./lord-selected-6.png"),
                require("./lord-selected-7.png"),
                require("./lord-selected-0.png"),
                require("./lord-selected-1.png"),
                require("./lord-selected-2.png"),
            ]
        })
    },
}
